import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SvgIcon } from '@material-ui/core';

export const ProductIcon = ({ className, ...props }) => {
  return (
    <SvgIcon className={classnames(className)} {...props} viewBox="0 0 28 22">
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 13.066L4.79902 14.3637M2.33158 9.58562L4.77212 10.8999M3.36004 6.6917L4.82593 7.6002M11.0097 6.02233L18.1699 9.70082L18.1699 12.2422M21.467 8.00688L14.5898 11.5396M14.5898 11.5396L7.71343 8.00688M14.5898 11.5396V19.6M13.7896 4.5937L8.41903 7.35322C7.80857 7.67165 7.42659 8.30676 7.42963 8.99828V15.0017C7.42675 15.6934 7.8091 16.3285 8.4199 16.6467L13.7896 19.4054C14.2922 19.6645 14.8882 19.6645 15.3909 19.4054L20.7606 16.6467C21.3712 16.3285 21.7532 15.6932 21.75 15.0017V8.99828C21.7534 8.30665 21.3713 7.67135 20.7606 7.35322L15.3909 4.5937C14.888 4.33542 14.2925 4.33542 13.7896 4.5937Z"
          stroke="#8D90A5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

ProductIcon.propTypes = {
  className: PropTypes.string,
};
